/* eslint-disable no-useless-escape */
/* eslint-disable  no-unused-expressions */
import React from 'react';
import styles from './BitaInput.module.scss';
import { LIMIT_DEFAULT_ENTER_VALUE } from '../../constants/common-constants';

const BitaInput = props => {
  const {
    handleChange,
    value = '',
    type,
    labelinput,
    id,
    externalTitle,
    postText,
    placeholder,
    text,
    maxlength,
    onBlur,
    showAsLabel,
    justify,
    tooltip,
    upper_limit,
    lower_limit,
    typeoutput,
    row_style,
    onKeyPress,
    autoFocus,
    validation,
    typeTime,
    ref,
  } = props;

  const numberWithCommas = n => {
    n = n.toString();
    const auxFloat = n.indexOf('.');
    const aux = n.replace(/,/g, '');
    const parts = aux.toString().split('.');
    return (
      Number(parts[0])
        .toString()
        .replace(/[^0-9-]/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      (parts[1] ? `.${parts[1].replace(/[^0-9]/g, '')}` : auxFloat > 0 ? '.' : '')
    );
  };

  const numberWithCommasTypeNumber = n => {
    if (n === '' || n === '-') return n;

    n = n.toString();
    const auxFloat = n.indexOf('.');
    const aux = n.replace(/,/g, '');
    const parts = aux.toString().split('.');

    // Preserve the negative sign for the case of "-0"
    const isNegative = parts[0].startsWith('-');
    const absolutePart = parts[0].replace('-', '');

    if (absolutePart === '' && isNegative) {
      return `-${parts[1] ? `.${parts[1].replace(/[^0-9]/g, '')}` : auxFloat > 0 ? '.' : ''}`;
    }

    const numberPart = absolutePart ? Number(absolutePart) : 0;

    return (
      (isNegative ? '-' : '') +
      numberPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      (parts[1] ? `.${parts[1].replace(/[^0-9]/g, '')}` : auxFloat > 0 ? '.' : '')
    );
  };

  const handleOnChange = newValue => {
    if (!handleChange) return;

    const onlyNumberTypeNumber = n => {
      if (n === '' || n === '-') return n;

      n = n.toString();
      const auxFloat = n.indexOf('.');
      const aux = n.replace(/,/g, '');
      const parts = aux.toString().split('.');

      return (
        parts[0].replace(/[^0-9-]/g, '') +
        (parts[1] ? `.${parts[1].replace(/[^0-9]/g, '')}` : auxFloat > 0 ? '.' : '')
      );
    };

    const onlyNumber = n => {
      n = n.toString();
      const auxFloat = n.indexOf('.');
      const aux = n.replace(/,/g, '');
      const parts = aux.toString().split('.');
      return (
        parts[0].replace(/[^0-9-]/g, '') +
        (parts[1] ? `.${parts[1].replace(/[^0-9]/g, '')}` : auxFloat > 0 ? '.' : '')
      );
    };

    // Improved function to validate during editing
    const validateDuringEditing = val => {
      // Allow values in the process of being edited
      if (val === '' || val === '-') return true;
      if (val === '-.') return true;
      if (val.endsWith('.')) return true;
      if (/^-0\.?$/.test(val)) return true;
      if (/^-\d*\.$/.test(val)) return true;

      // For complete values, validate limits
      const numericValue = parseFloat(val);
      if (Number.isNaN(numericValue)) return false;
      if (lower_limit !== undefined && numericValue < lower_limit) return false;
      if (upper_limit !== undefined && numericValue > upper_limit) return false;
      return true;
    };

    const validateNegativeLowerLimit = () => {
      if (lower_limit >= 0) {
        return parseFloat(`${newValue}9`) >= lower_limit;
      }

      return parseFloat(newValue) >= lower_limit;
    };

    if (type === 'number') {
      if (placeholder === 'Enter Value') {
        // Validate that it is a valid number
        const numericRegex = /^-?\d*\.?\d*$/;
        const cleanValue = newValue.replace(/,/g, '');
        if (cleanValue !== '' && cleanValue !== '-' && !numericRegex.test(cleanValue)) return;
        // Limit to digits LIMIT_DEFAULT_ENTER_VALUE
        const digitsOnly = cleanValue.replace(/[^\d]/g, '');
        if (digitsOnly.length > LIMIT_DEFAULT_ENTER_VALUE) return;
        // Validate limits
        if (validateDuringEditing(newValue)) {
          const formattedValue =
            typeoutput === 'simple'
              ? onlyNumberTypeNumber(newValue)
              : numberWithCommasTypeNumber(newValue);
          handleChange(formattedValue);
        }
      } else {
        if (
          upper_limit &&
          !lower_limit &&
          (parseFloat(newValue) <= upper_limit || newValue === '-' || newValue === '')
        ) {
          typeoutput === 'simple'
            ? handleChange(onlyNumber(newValue))
            : handleChange(numberWithCommas(newValue));
        }
        if (
          lower_limit &&
          !upper_limit &&
          (parseFloat(newValue) >= lower_limit || newValue === '-' || newValue === '')
        ) {
          typeoutput === 'simple'
            ? handleChange(onlyNumber(newValue))
            : handleChange(numberWithCommas(newValue));
        }
        if (
          lower_limit &&
          upper_limit &&
          ((validateNegativeLowerLimit() && parseFloat(newValue) <= upper_limit) ||
            newValue === '-' ||
            newValue === '' ||
            (lower_limit < 1 && parseFloat(newValue) === 0))
        ) {
          typeoutput === 'simple'
            ? handleChange(onlyNumber(newValue))
            : handleChange(numberWithCommas(newValue));
        }
        if (!upper_limit && !lower_limit) {
          typeoutput === 'simple'
            ? handleChange(onlyNumber(newValue))
            : handleChange(numberWithCommas(newValue));
        }
      }
    } else if (type === 'percentage') {
      if (newValue >= 0 && newValue <= 100) {
        handleChange(newValue.replace(/[^\d\.]/g, ''));
      }
    } else if (type === 'integer') {
      if (newValue === '' || (newValue !== '-' && (newValue >= lower_limit || !lower_limit))) {
        const regex = /([.]+)/;
        const negativeAfter = /\d[-]/;
        if (!regex.test(newValue) && !negativeAfter.test(newValue)) {
          handleChange(numberWithCommas(newValue));
        }
      }
    } else if (type === 'percentage_limit') {
      if (
        newValue === '' ||
        (lower_limit &&
          upper_limit &&
          parseFloat(newValue) >= lower_limit &&
          parseFloat(newValue) <= upper_limit)
      ) {
        const formattedValue =
          typeoutput === 'simple' ? onlyNumber(newValue) : numberWithCommas(newValue);
        handleChange(formattedValue);
      }
    } else if (validation) {
      const regex = new RegExp(validation);
      if (regex.test(newValue)) {
        handleChange(newValue);
      }
    } else {
      handleChange(newValue);
    }
  };

  return (
    <div
      className={`${styles.bitaInput} ${props.inputContainerStyle}`}
      style={{ marginLeft: justify && justify === 'flex-start' ? '0px' : 'auto' }}
    >
      <div className={`${styles.column}`}>
        {externalTitle ? (
          <span className={`${props.externalTitleStyle}`}>{externalTitle}</span>
        ) : null}
        <div className={`${styles.row} inputrow `}>
          {text ? <span className={`${styles.text} inputtext`}>{text}</span> : null}
          <input
            ref={ref}
            id={id}
            placeholder={placeholder}
            onKeyPress={onKeyPress}
            autoFocus={autoFocus}
            value={type === 'number' && typeoutput === 'simple' ? numberWithCommas(value) : value}
            className={
              showAsLabel
                ? `${props.inputStyle} inputStyle ${styles.bitaInputLabel} ${
                    row_style ? styles.row_input_style : ''
                  }`
                : `${props.inputStyle} inputStyle ${row_style ? styles.row_input_style : ''}`
            }
            type={typeTime || 'text'}
            onChange={evt => {
              handleOnChange(evt.target.value);
            }}
            maxLength={maxlength}
            onBlur={() => {
              if (placeholder === 'Enter Value') {
                if (lower_limit && parseFloat(value) < lower_limit) {
                  handleOnChange(lower_limit.toString());
                }
              } else if (lower_limit && lower_limit > value) {
                handleOnChange(lower_limit);
              }
              if (onBlur) {
                onBlur();
              }
            }}
            disabled={showAsLabel}
          />
          {labelinput ? (
            <label
              id={id}
              style={
                value === ''
                  ? text
                    ? { right: '50px' }
                    : null
                  : text
                  ? { right: '50px', top: '-17px' }
                  : { top: '-17px' }
              }
              htmlFor={id}
            >
              {labelinput}
            </label>
          ) : null}
          {postText ? <span className={`${styles.posttext} inputPostText`}>{postText}</span> : null}
          {tooltip && <span className={styles.tooltip}>{tooltip}</span>}
        </div>
      </div>
    </div>
  );
};

export default BitaInput;
